import { openAppDrawer } from "@client/utils/exclusiveDrawer";
import { ListChecksIcon } from "lucide-react";

/**
 * The app-bar button that opens the To Do rail.
 *
 * Split from the drawer itself because the app bar renders OUTSIDE the round
 * provider the rail's data lives in — the same split the Queue and General
 * Notes drawers use. The shared drawer store is the bridge.
 */
export function TodoDrawerTrigger() {
  return (
    <button
      type="button"
      title="To Do"
      aria-label="Open your to-do list for this round"
      onClick={() => openAppDrawer("todo")}
      className="relative flex h-9 w-9 items-center justify-center rounded-full text-text-secondary transition-colors hover:bg-surface-hover hover:text-text-primary"
    >
      <ListChecksIcon className="size-5" />
    </button>
  );
}
